import React, { useState, useEffect } from 'react';
import API from '../../services/api';
import { THEME } from '../../constants/theme';

const SuppliersSection = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [cities, setCities] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [viewDetail, setViewDetail] = useState(null); 
    const [editMode, setEditMode] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    
    const [status, setStatus] = useState({ show: false, msg: '', type: '' });

    const [formData, setFormData] = useState({
        supplier_name: '', contact_person: '', phone: '', email: '', address: '', city_id: '', ntn: ''
    });

    useEffect(() => { 
        fetchSuppliers(); 
        fetchCities();
    }, []);

    const showAlert = (msg, type = 'success') => {
        setStatus({ show: true, msg, type });
        setTimeout(() => setStatus({ show: false, msg: '', type: '' }), 3000);
    };

    const fetchSuppliers = async () => {
        try {
            const res = await API.get('/v1/suppliers');
            if (res.data.success) setSuppliers(res.data.data);
        } catch (err) { console.error("Error fetching suppliers"); }
    };

    const fetchCities = async () => {
        try {
            const res = await API.get('/v1/cities');
            if (res.data.success) setCities(res.data.data);
        } catch (err) { console.error("Error fetching cities"); }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editMode) {
                await API.put(`/v1/suppliers/${selectedId}`, formData);
                showAlert("Supplier updated successfully!");
            } else {
                await API.post('/v1/suppliers', formData);
                showAlert("New supplier and ledger created!");
            }
            resetForm();
            fetchSuppliers();
        } catch (err) { 
            showAlert("Error saving supplier data.", "error"); 
        }
    };

    const handleEdit = (s) => {
        setFormData({
            supplier_name: s.supplier_name,
            contact_person: s.contact_person || '',
            phone: s.phone,
            email: s.email || '',
            address: s.address || '',
            city_id: s.city_id || '',
            ntn: s.ntn || ''
        });
        setSelectedId(s.id);
        setEditMode(true);
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const resetForm = () => {
        setFormData({ supplier_name: '', contact_person: '', phone: '', email: '', address: '', city_id: '', ntn: '' });
        setShowForm(false);
        setEditMode(false);
        setSelectedId(null);
    };

    return (
        <div style={styles.container}>
            {status.show && (
                <div style={{
                    ...styles.statusAlert, 
                    backgroundColor: status.type === 'error' ? '#ef4444' : '#10b981'
                }}>
                    {status.msg}
                </div>
            )}

            <div style={styles.header}>
                <h3 style={styles.headerTitle}>🚛 Supplier Management</h3>
                <button onClick={() => setShowForm(!showForm)} style={showForm ? styles.closeBtn : styles.addBtn}>
                    {showForm ? '✖ Close' : '➕ Add Supplier'}
                </button>
            </div>

            {showForm && (
                <div style={styles.formCard}>
                    <h4 style={{marginTop: 0}}>{editMode ? 'Edit Supplier' : 'Register New Supplier'}</h4>
                    <form onSubmit={handleSubmit}>
                        <div style={styles.grid}>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Company\Owner Name *</label>
                                <input type="text" value={formData.supplier_name} onChange={e => setFormData({...formData, supplier_name: e.target.value})} required style={styles.input}/>
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Select City *</label>
                                <select value={formData.city_id} onChange={e => setFormData({...formData, city_id: e.target.value})} required style={styles.input}>
                                    <option value="">-- Choose City --</option>
                                    {cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                                </select>
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>NTN Number</label>
                                <input type="text" value={formData.ntn} onChange={e => setFormData({...formData, ntn: e.target.value})} style={styles.input}/>
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Phone (11 Digits) *</label>
                                <input 
                                    type="text" 
                                    placeholder="03001234567"
                                    value={formData.phone} 
                                    maxLength={11} 
                                    onChange={e => {
                                        const val = e.target.value.replace(/\D/g, ''); 
                                        setFormData({...formData, phone: val});
                                    }} 
                                    required 
                                    style={styles.input}
                                />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Email</label>
                                <input type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} style={styles.input}/>
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Contact Person</label>
                                <input type="text" value={formData.contact_person} onChange={e => setFormData({...formData, contact_person: e.target.value})} style={styles.input}/>
                            </div>
                        </div>
                        <div style={{marginTop: '15px'}}>
                            <label style={styles.label}>Office Address</label>
                            <textarea value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} style={styles.textarea}/>
                        </div>
                        <div style={styles.formActions}>
                            <button type="submit" style={styles.saveBtn}>Save Supplier</button>
                            <button type="button" onClick={resetForm} style={styles.cancelBtn}>Cancel</button>
                        </div>
                    </form>
                </div>
            )}

            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead>
                        <tr style={styles.thead}>
                             <th style={styles.th}>Account ID</th>
                            <th style={styles.th}>Company Name</th>
                            <th style={styles.th}>City</th>
                           
                           
                            <th style={{...styles.th, textAlign: 'center'}}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {suppliers.map(s => (
                            <tr key={s.id} style={styles.trow}>
                                <td style={styles.td}>
                                    {s.account_id ? (
                                        <span style={styles.badge}>{s.account_id}</span>
                                    ) : (
                                        <span style={{color: '#94a3b8', fontSize: '12px'}}>No Account</span>
                                    )}
                                </td>
                                <td style={styles.td}><b>{s.supplier_name}</b></td>
                                <td style={styles.td}>{s.city_name || '---'}</td>
                                
                               
                                <td style={{...styles.td, textAlign: 'center'}}>
                                    <button onClick={() => setViewDetail(s)} style={styles.detailBtn}>👁️ Details</button>
                                    <button onClick={() => handleEdit(s)} style={styles.actionBtn}>✏️</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* --- DETAIL MODAL with Account Info --- */}
            {viewDetail && (
                <div style={styles.modalOverlay}>
                    <div style={{...styles.modal, width: '650px'}}>
                        <h3>🏢 Supplier Details</h3>
                        
                        {/* Supplier Info */}
                        <div style={styles.sectionTitle}>Basic Info</div>
                        <div style={styles.detailGrid}>
                            <p><b>Company:</b> {viewDetail.supplier_name}</p>
                            <p><b>City:</b> {viewDetail.city_name}</p>
                            <p><b>NTN:</b> {viewDetail.ntn || 'N/A'}</p>
                            <p><b>Phone:</b> {viewDetail.phone}</p>
                            <p><b>Email:</b> {viewDetail.email || 'N/A'}</p>
                            <p><b>Contact:</b> {viewDetail.contact_person || 'N/A'}</p>
                            <p style={{gridColumn: '1/-1'}}><b>Address:</b> {viewDetail.address}</p>
                        </div>

                     

                        <button onClick={() => setViewDetail(null)} style={styles.closeModalBtn}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: { padding: '5px', position: 'relative' },
    statusAlert: {
        position: 'fixed', top: '20px', right: '20px', padding: '12px 20px', 
        color: '#fff', borderRadius: '8px', fontWeight: 'bold', zIndex: 2000,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)', transition: '0.3s'
    },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
    headerTitle: { margin: 0, color: '#1e293b' },
    addBtn: { padding: '10px 15px', background: THEME.secondary, color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' },
    closeBtn: { padding: '10px 15px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' },
    formCard: { background: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '20px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '5px' },
    label: { fontSize: '11px', fontWeight: 'bold', color: '#64748b' },
    input: { padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' },
    textarea: { width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1', minHeight: '50px' },
    formActions: { marginTop: '15px', display: 'flex', gap: '10px' },
    saveBtn: { padding: '10px 25px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' },
    cancelBtn: { padding: '10px 15px', background: '#f1f5f9', border: 'none', borderRadius: '6px' },
    tableWrapper: { background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0' },
    table: { width: '100%', borderCollapse: 'collapse' },
    thead: { background: '#f8fafc', borderBottom: '1px solid #e2e8f0' },
    th: { textAlign: 'left', padding: '15px', fontSize: '12px', color: '#64748b' },
    td: { padding: '15px', borderBottom: '1px solid #f1f5f9', fontSize: '14px' },
    badge: { background: '#dbeafe', color: '#1e40af', padding: '4px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold' },
    statusBadge: { padding: '3px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold' },
    detailBtn: { padding: '5px 10px', background: '#dbeafe', color: '#1e40af', border: 'none', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' },
    actionBtn: { background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' },
    modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
    modal: { background: '#fff', padding: '30px', borderRadius: '15px', width: '500px', boxShadow: '0 10px 30px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto' },
    sectionTitle: { fontSize: '14px', fontWeight: 'bold', color: '#1e293b', marginTop: '20px', marginBottom: '10px', paddingBottom: '8px', borderBottom: '2px solid #e2e8f0' },
    detailGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '20px' },
    closeModalBtn: { width: '100%', padding: '10px', background: '#1e293b', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }
};

export default SuppliersSection;